import type { RolUsuario } from '@/lib/supabase/tipos-bd'
import { NOMBRE_ROL } from '@/shared/dominio/roles'
import { iniciales } from '@/shared/utilidades/formato'

import estilos from './PaginaAuditoria.module.css'

/**
 * Quién fue: el avatar con sus iniciales en el color de su rol, y el rol
 * dicho como en MEGA. El color ayuda a ver de un vistazo si una acción la
 * hizo gerencia, un técnico o el sistema solo. «Sistema» es lo automático:
 * el enlace que el cliente abre, los crones, el chatbot.
 */
export function Avatar({ nombre, rol }: { nombre: string; rol: RolUsuario | null }) {
  return (
    <span
      className={`${estilos.avatar} ${estilos[`rol_${rol ?? 'sistema'}`] ?? ''}`}
      aria-hidden="true"
    >
      {rol ? iniciales(nombre) : '⚙'}
    </span>
  )
}

export function nombreDelRol(rol: RolUsuario | null): string {
  if (!rol) return 'Automático'
  return NOMBRE_ROL[rol as keyof typeof NOMBRE_ROL] ?? rol
}
